var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#2C2C33"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "black",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "black",
    fillOpacity: 0.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "black",
    fillOpacity: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "black",
    fillOpacity: 0.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "black",
    fillOpacity: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "black",
    fillOpacity: 0.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "black",
    fillOpacity: 0.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "black",
    fillOpacity: 0.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "black",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.0001L11.0001 14.0002L15 10",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxActive);
export default __webpack_public_path__ + "static/media/checkboxActive.94e6367e742089332b83ff9c49590384.svg";
export { ForwardRef as ReactComponent };